const selectors = {
  ajaxContainer: ".t4s-container-wrap [data-ntajax-container]",
  toggleFilter: ".t4s-btn-toggle-filter",
  filterResetWrapper: ".t4s-filter-reset-wrapper",
  filterReset: ".moft-dialog__reset",
  filterDialog: ".moft-dialog",
  filterDialogClose: ".moft-dialog .moft-dialog__close",
  filterDialogDone: ".moft-dialog .moft-dialog__done",
  filterAside: ".t4s-filters-aside",
  filterGroup: ".t4s-facet",
  filterTitle: ".t4s-facet-title",
  filterValuesContent: ".t4s-facet-content",
  filterValuesContentInner: ".t4s-facet-content .t4s-facet-content-inner",
  filterValuesUL: ".t4s-facet-content>ul",
  filterValue: ".t4s-filter__values>li",
  filterValueLink: ".t4s-filter__values>li>a",
  filterShowMoreButton: ".t4s-filter__show_more",
  filterCount: ".filter-values--count",
  dropdown: ".t4s-dropdown.t4s-dropdown__sortby",
  dropdownButton: ".t4s-dropdown__button",
  dropdownContent: ".t4s-dropdown__wrapper",
  sortbyItem: "[data-sortby-item]",
  sortbyLabel: ".sortby--label",
  filterJson: "#collection_filter_json",
  productColorMore: ".t4s-pr-color__item.is--colors-more a",
};
const marks = {
  asideShowed: "is--show-filter",
  asidePcShowed: "is--pc-show-filter",
  asideMobileShowed: "is--mb-show-filter",
  expanded: "is--enabled",
  filterShowMore: "is--show-more",
  loading: "is--loading",
  dropdownOpened: "is--opened",
  dropdownSelected: "is--selected",
  hide: "is--hide",
};
const elements = {
  ajaxContainer: document.querySelector(selectors.ajaxContainer),
  toggleFilter: document.querySelector(selectors.toggleFilter),
  filterCount: document.querySelector(selectors.filterCount),
  dropdown: document.querySelector(selectors.dropdown),
  dropdownButton: document.querySelector(selectors.dropdownButton),
  dropdownContent: document.querySelector(selectors.dropdownContent),
};
// 组的数据记录
const groupOptions = {
  // Key: group name handle, Value: {expanded: Boolean, contentHeight: String, showMore: Boolean}
};
// 初始化
const groupList = elements.ajaxContainer.querySelectorAll(selectors.filterGroup);
for (const group of groupList) {
  const groupHandle = group.getAttribute("data-handle");
  const isExpanded = group.classList.contains(marks.expanded);
  const height = group.querySelector(selectors.filterValuesContent).style.height ?? 0 + "px";
  groupOptions[groupHandle] = { expanded: isExpanded, contentHeight: height, showMore: false };
  // Hide items to show more
  const isShowMore = group.classList.contains(marks.filterShowMore);
  const items = group.querySelectorAll(selectors.filterValue);
  if (group.getAttribute("data-type") == "color" && window.innerWidth < 768) {
    // 移动端 Color 筛选组
    for (let i = 16; i < items.length; i++) {
      if (!isShowMore) items[i].style.display = "none";
    }
  } else {
    for (let i = 8; i < items.length; i++) {
      if (!isShowMore) items[i].style.display = "none";
    }
  }
  // if (window.innerWidth < 768) {
  //   // 移动端收起所有筛选组
  //   group.classList.remove(marks.expanded);
  //   groupOptions[groupHandle].expanded = false;
  // }
}
resizeFilterAside();
if (window.innerWidth < 768) {
  closeDialog();
}
const overlayEl = document.querySelector(".t4s-close-overlay");
overlayEl.addEventListener("click", closeDialog);
// Filter 按钮
elements.toggleFilter.addEventListener("click", function () {
  if (window.innerWidth < 768) {
    const isOpened = elements.ajaxContainer.classList.contains(marks.asideMobileShowed);
    isOpened ? closeDialog() : openDialog();
  } else {
    const isOpened = elements.ajaxContainer.classList.contains(marks.asidePcShowed);
    isOpened ? elements.ajaxContainer.classList.remove(marks.asideShowed) : elements.ajaxContainer.classList.add(marks.asideShowed);
    isOpened ? elements.ajaxContainer.classList.remove(marks.asidePcShowed) : elements.ajaxContainer.classList.add(marks.asidePcShowed);
  }
});
const resetBtn = document.querySelector(selectors.filterResetWrapper).querySelector(selectors.filterReset);
if (resetBtn) {
  resetBtn.addEventListener("click", function (e) {
    requestFilter(resetBtn.getAttribute("href"));
    e.preventDefault();
  });
}
reloadPcResetBtn();

function reloadPcResetBtn(PageElement = document) {
  // Filter JSON data
  let filterJson = [];
  try {
    filterJson = JSON.parse(PageElement.querySelector(selectors.filterJson).innerHTML);
    let count = 0;
    for (const filter of filterJson) {
      for (const value of filter.values) {
        if (value.active) count++;
      }
    }
    const resetWrapper = PageElement.querySelector(selectors.filterResetWrapper);
    if (count > 0) {
      resetWrapper.classList.remove(marks.hide);
      elements.filterCount.innerHTML = `(${count})`;
    } else {
      resetWrapper.classList.add(marks.hide);
      elements.filterCount.innerHTML = ``;
    }
  } catch (error) {
    console.error(error);
  }
}

function closeDialog() {
  elements.ajaxContainer.classList.remove(marks.asideShowed);
  elements.ajaxContainer.classList.remove(marks.asideMobileShowed);
  const overlayEl = document.querySelector(".t4s-close-overlay");
  const htmlEl = document.querySelector("html");
  if (!overlayEl) return;
  overlayEl.classList.remove("is--visible");
  htmlEl.classList.remove("t4s-lock-scroll");
}

function openDialog() {
  elements.ajaxContainer.classList.add(marks.asideShowed);
  elements.ajaxContainer.classList.add(marks.asideMobileShowed);
  const overlayEl = document.querySelector(".t4s-close-overlay");
  const htmlEl = document.querySelector("html");
  if (!overlayEl) return;
  htmlEl.classList.add("t4s-lock-scroll");
  overlayEl.classList.add("is--visible");
}

function listenSortby() {
  const closeSortBy = () => {
    elements.dropdown.classList.remove(marks.dropdownOpened);
    elements.dropdownContent.classList.remove(marks.dropdownOpened)
  }
  const openSortBy = () => {
    elements.dropdown.classList.add(marks.dropdownOpened);
    elements.dropdownContent.classList.add(marks.dropdownOpened)
  }
  document.addEventListener("click", function (e) {
    if (elements.dropdown.classList.contains(marks.dropdownOpened)) {
      closeSortBy();
    }
  });
  // Sortby 选项的点击事件
  elements.dropdown.addEventListener("click", function (e) {
    e.stopPropagation();
    const target = e.target;
    if (target && target.matches(selectors.sortbyItem)) {
      const value = target.getAttribute("data-value");
      closeSortBy();
      if (!value) return;
      for (const sortbyItem of elements.dropdown.querySelectorAll(selectors.sortbyItem)) {
        if (sortbyItem.classList.contains(marks.dropdownSelected)) sortbyItem.classList.remove(marks.dropdownSelected);
      }
      target.classList.add(marks.dropdownSelected);
      const labelEl = elements.dropdown.querySelector(selectors.sortbyLabel);
      labelEl.innerHTML = target.innerHTML;
      requestFilter(_addUrlParam(window.location.href, "sort_by", value));
    }
  });
  elements.dropdownButton.addEventListener("click", function () {
    const isOpened = elements.dropdown.classList.contains(marks.dropdownOpened);
    isOpened ? closeSortBy() : openSortBy();
  });
}

function listenFilterAside() {
  const groupList = elements.ajaxContainer.querySelectorAll(selectors.filterGroup);
  for (const group of groupList) {
    const titleEl = group.querySelector(selectors.filterTitle);
    const contentEl = group.querySelector(selectors.filterValuesContent);
    const groupHandle = group.getAttribute("data-handle");
    // Title
    titleEl.addEventListener("click", function () {
      if (!T4SThemeSP || !T4SThemeSP.reinitProductGridItem) {
        // 确保主题的一些函数加载完成
        return;
      }
      const isExpanded = group.classList.contains(marks.expanded);
      if (isExpanded) {
        group.classList.remove(marks.expanded);
        contentEl.style.height = '0';
      } else {
        group.classList.add(marks.expanded);
        contentEl.style.height = contentEl.scrollHeight + 'px';;
      }
      if (groupOptions[groupHandle]) {
        groupOptions[groupHandle].expanded = !isExpanded;
        groupOptions[groupHandle].contentHeight = contentEl.style.height;
      } else groupOptions[groupHandle] = { expanded: !isExpanded, contentHeight: contentEl.style.height, showMore: false }
    });
    // Show more
    const showMoreBtn = group.querySelector(selectors.filterShowMoreButton);
    if (showMoreBtn) {
      showMoreBtn.addEventListener("click", function () {
        const isShowMore = group.classList.contains(marks.filterShowMore);
        isShowMore ? group.classList.remove(marks.filterShowMore) : group.classList.add(marks.filterShowMore);
        groupOptions[groupHandle].showMore = !isShowMore;
        const items = group.querySelectorAll(selectors.filterValue);
        if (group.getAttribute("data-type") == "color" && window.innerWidth < 768) {
          // 移动端 Color 筛选组
          for (let i = 16; i < items.length; i++) {
            items[i].style.display = isShowMore ? "none" : "";
          }
        } else {
          for (let i = 8; i < items.length; i++) {
            items[i].style.display = isShowMore ? "none" : "";
          }
        }
        resizeFilterAside();
      });
    }
    // Reset button
    const resetBtn = elements.ajaxContainer.querySelector(selectors.filterReset);
    if (resetBtn) {
      resetBtn.addEventListener("click", function (e) {
        requestFilter(resetBtn.getAttribute("href"));
        e.preventDefault();
      });
    }
    // Filter item
    const valueEls = group.querySelectorAll(selectors.filterValue);
    for (const valueEl of valueEls) {
      valueEl.addEventListener("click", function (e) {
        const linkEl = valueEl.querySelector(selectors.filterValueLink);
        //T4SThemeSP.Facets.ntAjaxStart();
        //T4SThemeSP.Facets.loadPageContent(linkEl.getAttribute("href"))
        requestFilter(linkEl.getAttribute("href"));
        e.preventDefault();
      });
    }
  }
  // 移动端弹窗的关闭按钮
  const closeBtn = elements.ajaxContainer.querySelector(selectors.filterDialogClose);
  const doneBtn = elements.ajaxContainer.querySelector(selectors.filterDialogDone);
  if (closeBtn)
    closeBtn.addEventListener("click", closeDialog);
  if (doneBtn)
    doneBtn.addEventListener("click", closeDialog);
}

function listenProductCard() {
  elements.ajaxContainer.addEventListener("click", function (e) {
    const target = e.target;
    if (target && target.matches(selectors.productColorMore)) {
      // "+" 按钮的点击
      if (window.innerWidth <= 590) {
        window.location.href = target.getAttribute("href");
        e.stopPropagation(); // 阻止事件传播
      }
    }
  });
}

listenSortby();
listenFilterAside();
listenProductCard();

function onBeforeReplaceHtml(tempContainer) {
  const groupList = tempContainer.querySelectorAll(selectors.filterGroup);
  for (const group of groupList) {
    const groupHandle = group.getAttribute("data-handle");
    if (groupOptions[groupHandle]) {
      // 还原折叠
      groupOptions[groupHandle].expanded ? group.classList.add(marks.expanded) : group.classList.remove(marks.expanded);
      const contentEl = group.querySelector(selectors.filterValuesContent);
      const contentHeightOption = groupOptions[groupHandle].contentHeight;
      // 还原高度
      if (contentHeightOption) contentEl.style.height = contentHeightOption;
      // 还原 Showmore
      const isShowMore = groupOptions[groupHandle].showMore;
      isShowMore ? group.classList.add(marks.filterShowMore) : group.classList.remove(marks.filterShowMore);
      const items = group.querySelectorAll(selectors.filterValue);
      if (group.getAttribute("data-type") == "color" && window.innerWidth < 768) {
        // 移动端 Color 筛选组
        for (let i = 16; i < items.length; i++) {
          items[i].style.display = isShowMore ? "" : "none";
        }
      } else {
        for (let i = 8; i < items.length; i++) {
          items[i].style.display = isShowMore ? "" : "none";
        }
      }
    } else {
      // 新增
      const height = group.querySelector(selectors.filterValuesContent).style.height ?? 0 + "px";
      groupOptions[groupHandle] = { expanded: isExpanded, contentHeight: height, showMore: false };
    }
  }
}
function onAfterReplaceHtml() {
  T4SThemeSP.reinitProductGridItem();
  listenFilterAside();
  resizeFilterAside();
  reloadPcResetBtn();
}

// 更新筛选栏的尺寸
function resizeFilterAside() {
  const groupList = elements.ajaxContainer.querySelectorAll(selectors.filterGroup);
  for (const group of groupList) {
    const isExpanded = group.classList.contains(marks.expanded);
    if (!isExpanded) continue;
    const contentEl = group.querySelector(selectors.filterValuesContent);
    const innerEl = group.querySelector(selectors.filterValuesContentInner);
    const scrollHeight = innerEl.scrollHeight + 'px';
    if (contentEl.style.height != scrollHeight) {
      contentEl.style.height = scrollHeight;
    }
    const groupHandle = group.getAttribute("data-handle");
    const height = group.querySelector(selectors.filterValuesContent).style.height ?? 0 + "px";
    groupOptions[groupHandle].contentHeight = height;
  }
}

window.addEventListener('resize', resizeFilterAside, true);

/** 请求数据 */
function requestFilter(newUrl) {
  history.pushState('', '', newUrl);
  elements.ajaxContainer.classList.add(marks.loading);
  fetch(newUrl, {
    credentials: 'same-origin',
    method: 'GET'
  })
    .then((response) => response.text())
    .then(function (content) {
      const tempElement = document.createElement('div');
      tempElement.innerHTML = content;
      const tempContainer = tempElement.querySelector(selectors.ajaxContainer);
      onBeforeReplaceHtml(tempContainer);
      elements.ajaxContainer.innerHTML = tempContainer.innerHTML;
      onAfterReplaceHtml();
      try {
        fetch("");
      } catch (error) { }
    }).finally(() => {
      elements.ajaxContainer.classList.remove(marks.loading);
    });
}

/** 添加Url参数 */
function _addUrlParam(url, paramKey, paramValue) {
  var pattern = paramKey + '=([^&]*)';
  var replaceText = paramKey + '=' + paramValue;
  if (url.match(pattern)) {
    var tmp = '/(' + paramKey + '=)([^&]*)/gi';
    tmp = url.replace(eval(tmp), replaceText);
    return tmp;
  } else {
    if (url.match('[\?]')) {
      return url + '&' + replaceText;
    } else {
      return url + '?' + replaceText;
    }
  }
}

/** 替换Url参数值 */
function _replaceUrlParamValue(url, paramKey, paramValue) {
  let oUrl = url.toString();
  let re = eval('/(' + paramKey + '=)([^&]*)/gi');
  let nUrl = oUrl.replace(re, paramKey + '=' + paramValue);
  return nUrl;
}

console.log("==============Section-collection-v2 JS finished==========");